import { useEffect, useState } from "react";
import { computeLiveStatus } from "../lib/openStatus";

/**
 * Live "open / opens in / closed" badge.
 *
 * Re-evaluates every 60 seconds without re-fetching the business.
 *
 * Variants:
 *   "pill"   → small inline pill (used on cards)
 *   "block"  → larger block with bold label (used in business header)
 */
export default function OpenStatusBadge({ hours, variant = "pill", className = "" }) {
  const [status, setStatus] = useState(() => computeLiveStatus(hours));

  useEffect(() => {
    setStatus(computeLiveStatus(hours));
    const id = setInterval(() => setStatus(computeLiveStatus(hours)), 60_000);
    return () => clearInterval(id);
  }, [hours]);

  const isOpen = status.state === "open";
  if (variant === "block") {
    return (
      <div
        data-testid="open-status-badge"
        className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-semibold ${
          isOpen ? "bg-emerald-50 text-emerald-800" : "bg-rose-50 text-rose-800"
        } ${className}`}
      >
        <span className={`w-2 h-2 rounded-full ${status.dotClass} ${isOpen ? "animate-pulse" : ""}`} />
        {status.label}
      </div>
    );
  }

  return (
    <span
      data-testid="open-status-badge"
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-semibold ${
        isOpen ? "bg-emerald-600 text-white" : "bg-rose-600 text-white"
      } ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${isOpen ? "bg-white" : "bg-white"} ${isOpen ? "animate-pulse" : ""}`} />
      {status.label}
    </span>
  );
}
